import React from "react";
import { Grid, InputAdornment } from "@mui/material";
import "../../whatsapp interface/WhatsappPreview.css";

import {
  ComponentHeader,
  Paper,
  TextField,
  Label,
} from "../../../../components";

export default function TemplateFooter({ formikProps, addSample }) {
  return (
    <Paper>
      <Grid style={{ alignSelf: "center" }} size={12}>
        <ComponentHeader
          title={"Template Footer"}
          subtitle={
            "Add a short line of text to the bottom of your template message(Optional)."
          }
        />
      </Grid>

      <Grid size={12}>
        <TextField
          label="Footer Text"
          placeholder="Footer Text"
          name="templateFooter.text"
          formikProps={formikProps}
          disabled={Boolean(formikProps.values.ID) || Boolean(addSample)}
          inputProps={{
            maxLength: 60,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {formikProps.values?.templateFooter?.text?.length}/60
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Paper>
  );
}
